import React from 'react';
import { styled } from '@mui/material/styles';
import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material';

import formInitValues from '../assets/json/formInitValues.json';

import { useDispatch, useSelector } from 'react-redux';
import { selectCalc, changeCalc } from '../redux/calcSlice';

const UnitSelectorContainer = styled(Grid)(({ theme }) => ({
  padding:0,
  color:'#FFF',
  textAlign:'center',
  marginBottom:'36px'
}));

const UnitSelector = () => {
  const calc = useSelector(selectCalc);
  const dispatch = useDispatch();

  const handleChange = (e) => { 
    dispatch(changeCalc( { ...formInitValues[parseInt(e.target.value)] } ));
  }

  return (
    <React.Fragment>
    <UnitSelectorContainer container item xs={12}>
      <ToggleButtonGroup
        color="secondary"
        value={calc.unit}
        exclusive
        onChange={handleChange}
        aria-label="Calculator units"
      >
        <ToggleButton value={1} aria-label="API 650 Metric units">
          API 650 Metric units
        </ToggleButton>
        <ToggleButton value={3} aria-label="API 650 Customary units">
          API 650 Customary units
        </ToggleButton>
        <ToggleButton value={2} aria-label="EN 14015 Metric units">
          EN 14015 Metric units
        </ToggleButton>
      </ToggleButtonGroup>
    </UnitSelectorContainer>
    </React.Fragment>
  );
}

export default UnitSelector;
